<template>
  <div class="tools">
    <el-dropdown split-button size="mini" @click="$emit('newSess')" @command="newHandler">
      新建
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item class="new-dropdown-btn" command="sess" icon="el-icon-document-add">会话</el-dropdown-item>
        <el-dropdown-item class="new-dropdown-btn" command="dir" icon="el-icon-folder-add">目录</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>

    <el-button-group>
      <el-button size="mini" @click="$emit('cut')" icon="el-icon-scissors">剪切</el-button>
      <el-button size="mini" @click="$emit('copy')" icon="el-icon-copy-document">复制</el-button>
      <el-button size="mini" @click="$emit('paste')" icon="el-icon-document-copy">粘贴</el-button>
      <el-button size="mini" @click="$emit('details')" icon="el-icon-document">属性</el-button>
      <el-button size="mini" @click="$emit('refresh')" icon="el-icon-refresh">刷新</el-button>
      <el-button size="mini" @click="$emit('delete')" icon="el-icon-document-delete">删除</el-button>
    </el-button-group>

    <el-dropdown split-button size="mini">
      视图
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item class="view-dropdown-btn" icon="el-icon-tree">树状结构</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    
    <!-- <i class="el-icon-document-add btn" @click.capture.stop.exact="$emit('newSess')">&ensp;新建会话</i>
    <i class="el-icon-folder-add btn" @click="$emit('newDir')">&ensp;新建目录</i>
    <i class="el-icon-scissors btn" @click="$emit('cut')">&ensp;剪切</i>
    <i class="el-icon-copy-document btn" @click="$emit('copy')">&ensp;复制</i>
    <i class="el-icon-document-copy btn" @click="$emit('paste')">&ensp;粘贴</i> -->
    <!-- <el-popconfirm
      confirm-button-text='确认删除'
      cancel-button-text='取消'
      icon="el-icon-info"
      icon-color="red"
      title="确认删除选中的内容?"
      @confirm="$emit('delete')"
    >
      <i slot="reference" class="el-icon-document-delete btn">&ensp;删除</i>
    </el-popconfirm> -->
    <!-- <i class="el-icon-document btn" @click="$emit('details')">&ensp;属性</i>
    <i class="el-icon-refresh btn" @click="$emit('refresh')">&ensp;刷新</i> -->
    <el-input :id="searchID" ref="search" class="search-item" placeholder="搜索会话和目录" v-model="search" size="mini"
              @focus="searchFocusHandler"
              @keydown.native.capture.stop.up="$emit('up')"
              @keydown.native.capture.stop.down="$emit('down')"
              @keydown.native.capture.stop.left="$emit('left')"
              @keydown.native.capture.stop.right="$emit('right')"
              @keyup.native.enter="$emit('enter')">
    </el-input>
  </div>
</template>

<script>
export default {
  name: "sessionsTools",
  data() {
    return {
      search: "",
      searchID: "sess-list-search",
    }
  },
  watch: {
    search: function() {
      this.$emit("searchUpdate", this.search)
    }
  },
  mounted() {
    // 通过 $refs 引用当前组建时，首次渲染的时候 $refs 中的当前组件为 undefined，无法自动 focus，所以需要在 mounted 的时间点自己 focus 一下
    this.focus()
  },
  methods: {
    focus: function() {
      this.utils.domFocusById(this.searchID)
    },
    newHandler(command) {
      command === "sess" ? this.$emit('newSess') : this.$emit('newDir')
    },
    searchFocusHandler() {
      this.$refs.search.select()
    }
  },
}
</script>

<style scoped>
.tools {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1em;
}
.search-item {
  width: 220px;
}
.btn {
  cursor: pointer;
  user-select: none;
  padding: 6px;
  border-radius: 3px;
}
.new-dropdown-btn {
  width: 60px;
}
.view-dropdown-btn {
  width: 120px;
}
</style>